import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

import UserCalendars from './UserCalendars'

const DialogHeader = () => {
  return (
    <div style={styles.header}>
      Which calendar would you like to import?
    </div>
  )
}

const DialogFooter = ({ onCancelClicked, onImportClicked }) => (
  <div style={styles.footer}>
    <FlatButton
      key='cancel'
      label='Cancel'
      onTouchTap={onCancelClicked} />
    <FlatButton
      key='import'
      primary={true}
      label='Import'
      onTouchTap={onImportClicked} />
  </div>
)

DialogFooter.propTypes = {
  onCancelClicked: PropTypes.func.isRequired,
  onImportClicked: PropTypes.func.isRequired
}

export default class CalendarsOptionsDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool,
    calendarsState: PropTypes.object.isRequired,
    onImportCancelled: PropTypes.func.isRequired,
    onImportClicked: PropTypes.func.isRequired,
    onCalendarToggled: PropTypes.func.isRequired
  }

  handleCancelClicked = event => {
    event.preventDefault()
    this.props.onImportCancelled()
  }

  handleImportClicked = event => {
    event.preventDefault()
    if (this.props.calendarsState.selectedForImport().length) {
      this.props.onImportClicked()
    }
    else {
      alert('Please, select at least one non-imported calendar.')
    }
  }

  render() {
    return (
      <Dialog open={this.props.open}
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}>
        <DialogHeader />
        <UserCalendars
          calendarsState={this.props.calendarsState}
          onCalendarToggled={this.props.onCalendarToggled} />
        <DialogFooter
          onCancelClicked={this.handleCancelClicked}
          onImportClicked={this.handleImportClicked} />
      </Dialog>
    )
  }
  
}

const styles = {

  dialogContent: {
    borderRadius: 2,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width: 600
  },

  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: 2
  },

  header: {
    padding: 16,
    borderRadius: 2,
    fontWeight: 500,
    fontFamily: 'Roboto',
    fontSize: 15,
    backgroundColor: '#f7f7f7',
    color: 'rgba(0, 0, 0, 0.71)',
    boxShadow: 'inset 0 1px 0 0 rgba(0, 0, 0, 0.05)'
  },

  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: 16
  }

}



// WEBPACK FOOTER //
// ./src/schedule/gcal/CalendarsOptionsDialog.js